import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { Category, CategoryRequest, CategoryTree } from '../models/category.model';

@Injectable({ providedIn: 'root' })
export class CategoryService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${API_BASE_URL}/categories`;

  getTree(): Observable<CategoryTree[]> {
    return this.http.get<CategoryTree[]>(this.baseUrl);
  }

  create(request: CategoryRequest): Observable<Category> {
    return this.http.post<Category>(this.baseUrl, request);
  }

  update(id: string, request: CategoryRequest): Observable<Category> {
    return this.http.put<Category>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  setOrder(parentId: string | null, ids: string[]): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/order`, { parentId, ids });
  }

  uploadImage(id: string, file: File): Observable<Category> {
    const form = new FormData();
    form.append('file', file, file.name);
    return this.http.post<Category>(`${this.baseUrl}/${id}/image`, form);
  }

  deleteImage(id: string): Observable<Category> {
    return this.http.delete<Category>(`${this.baseUrl}/${id}/image`);
  }
}
